import {Cell, Field, Button, CellGroup, Popup, Picker, Tag, Toast, Dialog} from 'vant';
import '@/assets/js/public/qqdt/geolocation.min'
import UploadImage from "@/components/upload-image/UploadImage"
import {baseApiMap} from '@/api/base'
import {memberApi} from "@/api/member";
import {apphubApiMap} from '@/api/apphub'
import {checkCarNum} from '@assets/js/api/Regular'
import { Source } from '@/utils/source'
import Bridge from '@/utils/bridge'

/**
 * Description:
 * Author: yangqs
 * Date: 2019-08-20
 * Time: 10:43
 */
export default {
    name: "MoveCar",
    components: {
        UploadImage,
        [Cell.name]: Cell,
        [Tag.name]: Tag,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [Field.name]: Field,
        [Button.name]: Button,
        [CellGroup.name]: CellGroup,
        [Toast.name]: Toast,
        [Dialog.name]: Dialog
    },
    data() {
        return {
            // geolocation: new qq.maps.Geolocation("Y7SBZ-H4VC5-D5GIU-Q6Y7X-26X62-LSBPW", "myapp"),
            geolocation: new qq.maps.Geolocation("ORVBZ-M6GWD-4WQ46-HCSDX-KFTZQ-55F7H", "myapp"),
            LP_TITLE: "堵路车牌: 鄂",
            message: '',
            carModel: '',
            cartype: '',
            LicensePlate: '',
            address: '',
            msgid: '',
            showPicker: false,
            required: true,
            maxLength: 3,
            columns: []
        }
    },
    created() {

    },
    mounted() {
        this.getCarType()
        //获取当前位置
        this.geolocation.getLocation(this.showPosition, this.showErr, this.options);
        this.logger.visit('207','0')
    },
    methods: {
        /**
         * 获取车辆类型
         */
        getCarType() {
            this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.vehicleType`).then(res => {
                if (res.data.succ) {
                    const data = res.data.data
                    data.forEach(obj => {
                        if (obj.pid !== 'root') {
                            this.columns.push({
                                text: obj.title, value: obj.val
                            })
                        }
                    })
                }
            })
        },
        //获取当前定位
        showPosition(position) {
            var addrDetail = position.province + position.city + position.addr;
            this.address = addrDetail;
            console.log(addrDetail)
            console.log(position);
        },
        showErr() {
            console.log("定位失败！");
        },
        /**
         * 初始化用户
         */
        // 用户信息非必需
        // async initUser() {
        //     let _self = this;
        //     if (_self.$cookie.getUser()) {
        //         return _self.$cookie.getUser();
        //     }
        //     let userInfo = {};
        //     try {
        //         const res = await _self.$httpUtils.getGatewayUtils(memberApi.getUserInfo)
        //         debugger
        //         console.log(res)
        //         if (res.data.succ) {
        //             userInfo = res.data.data
        //             _self.$cookie.setUser(userInfo)
        //         } else {
        //             Toast.fail('网络异常，请检查网络')
        //         }
        //     } catch (e) {
        //         Toast.fail('服务器运行失败，请稍后再试。')
        //         console.log(e)
        //     }
        //     return userInfo;
        // },
        /**
         * 获取车辆类型
         * @param value
         */
        onConfirm(value) {
            this.carModel = value.text;
            this.carType = value.value;
            this.showPicker = false;
        },
        /**
         * 提交堵路移车信息
         * @returns {Promise<boolean>}
         */
        async submitMoveCarData() {
            // let express = /^[A-Z]{1}[A-Z_0-9]{5}$/;
            if (!this.LicensePlate.trim()) {
                Toast("请输入堵路车牌");
                return false;
            } else if (!checkCarNum((this.LicensePlate))) {
                Toast("请输入正确的车牌");
                return false;
            } else if (!this.carModel) {
                Toast("请选择堵路车型");
                return false;
            } else if (!this.address.trim()) {
                Toast("请输入具体堵路车地点");
                return false;
            } else {
                let data = {
                    address: this.address, // 挪车位置
                    cartype: this.carType, // 堵车车辆类型
                    carnumber: this.LicensePlate, // 车牌号
                    waytype: 'message' //移车方式 短信方式：message ，  电话方式：phone，默认message
                };
                if (this.$refs.uploadImage.imageList.length>0) {
                    data.picId = ''
                    this.$refs.uploadImage.imageList.forEach((obj=>{
                        data.picId = data.picId + obj.guid + ','
                    }))
                }
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                try {
                    const res = await this.$httpUtils.postGatewayUtils(apphubApiMap.roadtrafficJwt, data);
                    Toast.clear()
                    if (res.data.succ) {
                        let source = Source.getSource()
                        if(source === 'IOS') {
                            // 调用ios结束当前页面
                            Bridge.callhandler('goNewVC', { "newPath": '', "newVC": "goBack" }, (data) => {
                            });
                        } else if (source === 'ANDROID') {
                            // 调用安卓结束当前页面
                            window.android.goBack()
                        } else {
                            // 微信
                            this.msgid = res.data.msg;
                            Dialog.alert({
                                title: '提交成功',
                            }).then(() => {
                                this.$router.push('/')
                            })
                        }
                        //this.savaORoadBlock();
                    } else {
                        Dialog.alert({
                            title: `提交失败：${res.data.msg}`,
                        })
                    }
                } catch (e) {
                    Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(e)
                }
            }
        },
        async savaORoadBlock() {
            let fileData = {
                guid: this.msgid,//new Guid().newGUID()
                cartype: this.carType,
                carnum: '鄂' + this.LicensePlate,
                address: this.address,
                picid: this.$refs.uploadImage.imageList.length > 0 ? this.imageList[0].guid : null,
            }
            try {
                const res = this.$httpUtils.postGatewayUtils(apphubApiMap.roadblockJwt, fileData)
                if (res.data.succ) {
                    Dialog.alert({
                        title: '提交成功',
                    }).then(() => {
                        let source = Source.getSource()
                        if(source === 'IOS') {
                            // 调用ios回到首页方法
                            Bridge.callhandler('goNewVC', { "newPath": '', "newVC": "goHome" }, (data) => {
                            });
                        } else if (source === 'ANDROID') {
                            // 调用安卓回到首页的方法
                            window.android.goHome()
                        } else {
                            this.$router.push('/')
                        }
                    })
                    // _self.$router.push('/');
                    // _self.$router.push('/move-car/result');
                } else {
                    Dialog.alert({
                        title: `提交失败：${res.data.msg}`,
                    }).then(() => {
                        this.$router.push('/')
                    })
                }
            } catch (e) {
            }
        },
        async toUpper() {
            this.LicensePlate = this.LicensePlate.trim().toUpperCase();
        }

    }
}
